import profPicSm from '../assets/others/p1.jpg'
import { motion, useAnimation, useInView } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import circularText from "../assets/circular-text-3.svg";
import reactSq from '../assets/logo/square/react-sq.png'
// // import reduxSq from '../assets/logo/square/redux.png'
// import mssqlSq from '../assets/logo/square/ms-sql-2.png'
// import aspnetSq from '../assets/logo/square/net-sq.png'
// import mssqlSq from '../assets/logo/square/ms-sql-2.png'
// import aspnetSq from '../assets/logo/square/net-sq.png'
import figmaSq from '../assets/logo/square/figma-3.png'
import mysqlSq from '../assets/logo/square/mysql-3.png'
import netSq from '../assets/logo/square/net-sq-2.png'
import nodeSq from '../assets/logo/square/nodejs2.png'
import expressSq from '../assets/logo/square/expressjs.png'
import tailwindSq from '../assets/logo/square/tailwind-2.png'
import sequelizeSq from '../assets/logo/square/sequelize.png'
import computerGuy from '../assets/others/computer-guy.png'
import oracleSq from '../assets/logo/square/oracle-sq-2.png'
import mongoDbSq from '../assets/logo/square/mongodb-2.png'
import nextjsSq from "../assets/logo/square/nextjs.png";
import angularSq from "../assets/logo/square/angular.png";

const techItems = [
    { name: "React", img: reactSq },
	{ name: "Next.js", img: nextjsSq },
	{ name: "Angular", img: angularSq },
	// { name: "Redux", img: reduxSq },
	{ name: "Node.js", img: nodeSq },
	{ name: "Express", img: expressSq },
	{ name: "MySQL", img: mysqlSq },
	{ name: "MongoDB", img: mongoDbSq },
	{ name: "Sequelize", img: sequelizeSq },
	{ name: ".NET", img: netSq },
	{ name: "Oracle Database", img: oracleSq },
	// { name: "ASP.NET Core MVC", img: aspnetSq },
	// { name: "Microsoft SQL Server", img: mssqlSq },
	{ name: "Tailwind", img: tailwindSq },
	{ name: "Figma", img: figmaSq },
];

export const Expertise2 = () => {
    const controls = useAnimation();
    const [scrollPosition, setScrollPosition] = useState(0);
    const [isPopOverActive, setIsPopOverActive] = useState(null)

    const togglePopOver = (index) => {
        setIsPopOverActive((prevIndex) => (prevIndex === index ? null : index))
    }

    const gridAnimationVariant = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
            }
        }
    }

    const techStackRef = useRef(null)
    const isInView = useInView(techStackRef, { once: true })

    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        // Adjust the scroll threshold as needed
        const scrollThreshold = 10; // Adjust this value based on when you want the animation to start

        if (scrollPosition > scrollThreshold) {
            controls.start({ rotate: 40 });
        } else {
            controls.start({ rotate: 0 });
        }
    }, [scrollPosition, controls]);

    return (
        <>
            <section className="bg-gradient-to-b from-[#E2EDED] from-[45%] font-jakarta px-[16px] md:px-[32px] lg:px-[160px] md:py-[0.5rem]">

                {/* bg-[#F2F7F7], #E2EDED  */}
                <section className="px-[16px] md:flex justify-between pt-[3.5rem] pb-[2rem] md:py-[6rem]">
                    {/* Photos MD */}
                    <section className="flex items-start justify-start gap-[0.75rem] mb-[2.5rem] md:mb-0">
                        <img
                            src={profPicSm}
                            alt=""
                            className="rounded-full h-[5.5rem] md:h-[7rem]"
                        />
                        <div className="relative bg-[#f5f9f9] rounded-full">
                            <motion.img
                                src={circularText}
                                alt=""
                                // animate={controls}
                                animate={{ rotate: 360 }}
                                transition={{
                                    repeat: Infinity,
                                    repeatType: "loop",
                                    duration: 10,
                                    ease: "linear",
                                }}
                                className="h-[5.5rem] md:h-[7rem]"
                            />
                            <img src={computerGuy} alt="" className="absolute h-[2rem] md:h-[2.25rem] -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" />
                        </div>
                    </section>
                    {/* Text */}
                    <div className="md:px-0 text-[18px] md:text-[20px]">
                        <span className="text-[#002921] opacity-[0.8] font-medium"></span>
                        <p className="text-[#7a8f8b] font-normal max-w-[25rem]">
                            {/* #828997 */}
                            <span className="text-[#002921] whitespace-pre-wrap">
                                I specialize in full stack web development and web design,{" "}
                            </span>
                            creating memorable digital experiences that drive value for my
                            clients and their customers. Currently based in Jakarta,
                            Indonesia.
                        </p>
                        <section className="flex items-center gap-[0.3rem] mt-[3rem]">
                            <div className="order-last md:order-first flex items-center justify-center p-[1rem] rounded-full bg-[#E0FD60]">
                                <svg
                                    width="21"
                                    height="21"
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="rotate-90 md:rotate-180 "
                                >
                                    <path
                                        d="M10.3291 5.68945H20.6694C20.727 5.68945 20.7738 5.73622 20.7738 5.7939V16.1342"
                                        stroke="#22333B"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                    <path
                                        d="M20.7744 5.68945L7.19629 19.2676"
                                        stroke="#22333B"
                                        stroke-width="2.08894"
                                        stroke-miterlimit="10"
                                    ></path>
                                </svg>
                            </div>
                            <div
                                id="button-animation"
                                className="flex items-center group gap-[0.6rem] w-max rounded-full border border-[#c7cad1] font-medium text-[17px] text-[#a7adb8] py-[0.8rem] px-[1.4rem]"
                            >
                                Tech I Use
                            </div>
                        </section>
                    </div>
                </section>
                <section className="flex justify-center pt-[2rem] md:pt-0 pb-[3rem] md:pb-[3.5rem]">
                    <motion.div
                        ref={techStackRef}
                        variants={gridAnimationVariant}
                        initial="hidden"
                        animate={isInView ? "show" : {}}
                        className="flex flex-wrap gap-[0.5rem] md:gap-[0.75rem] justify-center max-w-[50rem]"
                    >
                        {techItems.map((item, index) => (
                            <motion.div
                                variants={{ hidden: { opacity: 0 }, show: { opacity: 1 } }}
                                key="index"
                                id="tech-icon-animation"
                                className="group relative border border-[#e0e2e6] rounded-xl p-5 cursor-pointer hover:scale-[1.1]"
                                onMouseEnter={() => togglePopOver(index)}
                                onMouseLeave={() => setIsPopOverActive(null)}
                            >
                                <img
                                    key={index}
                                    src={item.img}
                                    alt=""
                                    // className="h-[4rem] md:h-[4rem] object-cover opacity-[0.8]"
                                    className="h-[2.5rem] md:h-[3rem] object-cover grayscale-[100%] md:opacity-[0.7] group-hover:grayscale-0 group-hover:opacity-[1] transition ease-in-out delay-100"
                                />
                                {isPopOverActive === index && (
                                    <motion.div
                                        initial={{ opacity: 0, y: 25 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.3, ease: "easeOut", delay: 0.2 }}
                                        className="absolute w-max top-[-2rem] group-odd:left-0 group-even:right-0 bg-[#E0FD60] px-[0.8rem] py-[0.2rem] rounded-xl"
                                    >
                                        <p className="text-[13px] text-[#002921] text-center opacity-[0.8] font-medium">{item.name}</p>
                                    </motion.div>
                                )}
                            </motion.div>
                        ))}
                    </motion.div>
                </section>
            </section>
        </>
    );
}